<template lang="html">
    <list-template ref="list-template" actionUrl="lcwpbusiness/findBusiness.action" :queryParams="queryParams">
      <template slot="search" scope="scope">
        <el-col :span="5">
          <el-input v-model="queryParams.keyword" placeholder="请输入商家名或电话"></el-input>
        </el-col>
        <el-button @click="$refs['list-template'].search()" >搜索</el-button>
      </template>

      <template slot="item" scope="scope">
        <el-card class="basic-margin" v-bind:key="index" v-for="(data,index) in scope.datas">
           <el-row>
            <el-col :span="3">
              <img :src="data.headImg" style="width:150px;height:100px;">
            </el-col>
            <el-col :span="12" >
              <h4 style="margin-top: -2px">
                {{data.businessName}}
              </h4>
                <h4>
                    <el-tag type="warning">{{data.channelName}}</el-tag>
                    <el-tag type="success" size="small" style="margin-left: 10px;">{{data.status | statusFilter}}</el-tag>
                    <el-tag type="info" size="small" style="margin-left: 10px;">{{data.type}}</el-tag>
                    <el-tag type="info" size="small" style="margin-left: 10px;">在售商品 {{data.goodsSize}} 件</el-tag>
                    <el-tag type="info" size="small" v-if="data.loginDays" style="margin-left: 10px;">{{data.loginDays}} 天未登录</el-tag>
                    <el-tag size="small" type="info" v-if="data.inviterName" style="margin-left: 10px;"> 邀请人：{{data.inviterName}}</el-tag>
                </h4>
              <p>公司地址：{{data.detailAddress}}</p>

              <p>服务类型：{{data.serviceType}}</p>

              <p>管理人员：{{data.contacts}} - {{data.phone}}</p>

              <p>创建人员：申请入驻 - {{data.createTime | dateTimeFormat}}</p>

              <p>员工数 {{data.employeeCount}} 人 | {{data.busienssUserBrowseCount}} 人浏览 {{data.busienssBrowseCount}} 次 | {{data.callPhoneUserBrowseCount}} 人拨打 {{data.callPhoneBrowseCount}} 次 </p>

            </el-col>
            <el-col :span="9" style="text-align:right;">

              <el-button  type="primary" @click="$router.push({name:'入驻申请审核', params: { id: data.id }})">立即审核</el-button>

            </el-col>

          </el-row>
        </el-card>
      </template>
    </list-template>
</template>

<script>
import ListTemplate from '@/components/ListTemplate'
import BasicPager from '@/mixins/BasicPager'
export default {
  name: 'joined-business',
  extends: BasicPager,
  data: function () {
    return {
      isOperation: false,
      queryParams: {
        status: '3',
        channelId: null
      }
    }
  },
  components: {
    ListTemplate
  },
  filters: {
    statusFilter: function (valueFilter) {
      let str = ''
      switch (valueFilter) {
        case 1:
          str = '已下架'
          break
        case 2:
          str = '已上架'
          break
        case 3:
          str = '申请入驻'
      }

      return str
    }
  },
  created: function () {
    let that = this

    if (this.loginInfo.loginPath == 'channel') {
      this.queryParams.channelId = this.loginInfo.id
    }
  },
  activated: function () {
    this.$refs['list-template'].loadList()
  },
  methods: {
    onInputConfirm: function () {
      this.$refs['list-template'].search()
    }
  }
}
</script>

<style lang="css" scoped>
</style>
